<template>
    <modal
        name="forward-modal"
        height="auto"
    >
        <div class="container">
            <div class="header-wrapper">
                <h1 class="header-title">Reenviar Cotización</h1>
            </div>
            <div class="body">
                <p class="comment-title">COMENTARIO</p>
                <textarea
                    class="comment-area"
                    placeholder="Escribe un comentario al broker"
                    @input="changeTextarea"
                    v-model="quotationComment"
                />
            </div>
            <div class="buttons-wrapper">
                <button @click="close" class="secundary-button-xs">Cancelar</button>
                <button
                    @click="forward"
                    :class="{ disabled: isDisabled}"
                    class="primary-button-xs"
                    :disabled="isDisabled"
                >Enviar Cotización
                </button>
            </div>
        </div>
    </modal>
</template>
<script>
import SiteConfig from '../../services/positiva';

export default {
    name:"ForwardModal",
    props:{
        tecnicaQuotation: Object,
    },
    data(){
        return{
            isDisabled: true,
            quotationComment:"",
        }
    },
    methods: {
        close(){
            this.$emit('close');
        },
        forward(){
          this.$emit('forward', this.quotationComment);
        },
        showFileName(name) {
                return SiteConfig.showFileName(name, 32, 10)
        },
        changeTextarea() {
            if(this.quotationComment == "" ){
                this.isDisabled = true
            }else {
                this.isDisabled = false
            }
        }
    }
}
</script>
<style lang="scss" scoped>

.container{
    background-color: #fff;
    border: 1px solid #e8e8e8;
    box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.14);
    width: 600px;
    height: auto;
}
.header-wrapper{
    border-bottom: 1px solid rgba(70,72,74,0.1);
    margin-bottom: 20px;
    padding: 0.7em 0.9em;
}
.header-title{
    color: #2a2a2e;
    font-family: 'miraimedium';
    font-size: 1.125em;
}
.body{
    padding: 0 30px;
}
.comment-title{
    margin-bottom: 6px;
}
.comment-area{
    border: 1px solid #e8e8e8;
    border-radius: 5px;
    font-size: 14px;
    height: 100px;
    padding: 10px;
    margin-bottom: 14px;
    width: 100%;
}

.buttons-wrapper{
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
}

</style>
